import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const PaymentDataTable = ({ attributes, tableData, primaryKey, columnHeads=attributes }) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columnHeads.map((columnTitle) => (
              <TableCell align="center" sx={{fontWeight:`bold`}}>
                {columnTitle
                  .split("_")
                  .map((str) => str.charAt(0).toUpperCase() + str.slice(1)).join(" ")}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row) => {
            return (
              <TableRow
                key={row[primaryKey]}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {attributes.map((key) => (
                  <TableCell align="center">{row[key]}</TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PaymentDataTable;
